import { withScript } from '../hocs/with-script';

import { KATEX_URL, KATEX_CSS } from './constants';
import { isShouldLoadKatex } from './is-should-load';

export const withKatex = withScript([KATEX_URL, KATEX_CSS], isShouldLoadKatex);
